import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/types'
import { useLocation } from 'react-router-dom'
import { IMfeManifest, IMfeRoute } from '../types'

type MfeRouteState =
  | { isCurrentRouteFromMfe: false; route: null }
  | { isCurrentRouteFromMfe: true; route: IMfeRoute }

const useMfeRoute = (): MfeRouteState => {
  const location = useLocation()

  const manifests = useSelector((state: RootState): IMfeManifest[] => state.mfe.manifests)

  return useMemo((): MfeRouteState => {
    const { pathname: currentRoutePath } = location

    for (const manifest of manifests) {
      for (const route of manifest.routes) {
        const composedRoutePath: string = `/${manifest.basePath}/${route.path}`

        if (composedRoutePath === currentRoutePath) return { isCurrentRouteFromMfe: true, route }
      }
    }

    return { isCurrentRouteFromMfe: false, route: null }
  }, [location, manifests])
}

export default useMfeRoute
